import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiLinkedin } from "react-icons/fi";
import TitlesLandingPage from "../titles";
import tohidAvatar from "../../../assets/images/tohid.jpg";
import mohammadAvatar from "../../../assets/images/mohammad.jpg";
import aryanAvatar from "../../../assets/images/aryan.jpg";
import javadAvatar from "../../../assets/images/javad.jpg";
import samiraAvatar from "../../../assets/images/samira.jpg";
import mehdiAvatar from "../../../assets/images/mehdi.jpg";
import zahraavatar from "../../../assets/images/zahra.jpg";
import mahyaravatar from "../../../assets/images/mahyar.jpg";
import yarmohammadiAvatar from "../../../assets/images/yarmohammadi.jpg";

export default function TeamSection({ isDarkTheme }) {
  const team = useMemo(
    () => [
  
      {
        name: " جواد حسن پور",
        role: "Network Engineer",
        bio: "تخصص در سیسکو (CCNA، CCNP، CCIE) و فورتی‌نت (NSE 4، NSE 7). تمرکز بر بهینه‌سازی زیرساخت شبکه و ایمن‌سازی سیستم‌های سازمانی",
        avatar: javadAvatar,
        linkedin: "https://www.linkedin.com/in/javad-hasanpour",
      },
      {
        name: " سمیرا رضایی",
        role: "Virtualization expert",
        bio: "طراحی، پیاده‌سازی و مدیریت زیرساخت‌های مجازی (VMware, Hyper-V, vSphere) با هدف بهینه‌سازی منابع، افزایش امنیت و کاهش هزینه‌های سازمانی.",
        avatar: samiraAvatar,
        linkedin: "https://www.linkedin.com/in/samira-rezaee-8860b018a",
      },
      {
        name: " توحید شعبانلو",
        role: "Full Stack Developer",
        bio: "طراحی و توسعه کامل نرم‌افزار از سمت کاربر تا سرور، شامل توسعه Front-End (React, Next.js) و Back-End (Node.js, Express, Databases) با تأکید بر مقیاس‌پذیری، امنیت و یکپارچگی سیستم.",
        avatar: tohidAvatar,
        linkedin: "https://www.linkedin.com/in/tohidshabanloo/",
      },
      // {
      //   name: " وحید شعبانلو",
      //   role: "Full Stack Developer",
      //   bio: "طراحی و توسعه کامل نرم‌افزار از سمت کاربر تا سرور، شامل توسعه Front-End (React, Next.js) و Back-End (Node.js, Express, Databases) با تأکید بر مقیاس‌پذیری، امنیت و یکپارچگی سیستم.",
      //   avatar: vahidAvatar,
      // },
      {
        name: " زهرا باقرزاده",
        role: "Cybersecurity",
        bio: "شناسایی و مدیریت تهدیدات امنیتی، طراحی راهکارهای حفاظت از داده‌ها و شبکه، انجام تست نفوذ و نظارت بر رعایت استانداردهای امنیت سایبری در سازمان.",
        avatar: zahraavatar,
        linkedin: "https://www.linkedin.com/in/zahra-bagherzadeh-0831b8200",
      },
     
      {
        name: " محمد جعفرقلی",
        role: "Microsoft expert",
        bio: "ارائه راهکارهای تخصصی، پشتیبانی و بهینه‌سازی محصولات و سرویس‌های مایکروسافت (Windows, Office 365, Azure) برای کاربران و سازمان‌ها.",
        avatar: mohammadAvatar,
        linkedin: "https://www.linkedin.com/in/mohammad-milad-jafargholi/",
      },
      {
        name: " آریان حامد",
        role: "Microsoft expert",
        bio: "ارائه راهکارهای تخصصی، پشتیبانی و بهینه‌سازی محصولات و سرویس‌های مایکروسافت (Windows, Office 365, Azure) برای کاربران و سازمان‌ها.",
        avatar: aryanAvatar,
        linkedin: "https://www.linkedin.com/in/aryan-hamed",
      },
      {
        name: "مهیار تجددی",
        role: "Architecture and 3D visualization",
        bio: "نمایش واقع‌گرایانه طرح‌های معماری قبل از ساخت با استفاده از مدل‌سازی سه‌بعدی",
        avatar: mahyaravatar,
        linkedin: "https://www.linkedin.com/in/mahyar-tajaddodi-nodehi",
      },
      {
        name: "مهدی فرجی",
        role: "Senior Network and Infrastructure Consultant",
        bio: "مشاور و کارشناس ارشد شبکه و زیرساخت مدرس شبکه های کامپیوتری",
        avatar: mehdiAvatar,
        linkedin: "https://www.linkedin.com/in/mahdi-faraji",
      },
      {
        name: "مهدی یارمحمدی",
        role: "کارشناس ارشد Data Center",
        bio: "مجازی سازی استورج های Hitachi و Unity، سیسکو، میکروتیک، لینوکس، فایروال، مایکروسافت",
        avatar: yarmohammadiAvatar,
      },
    
     
  
    

    ],
    []
  );

  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoRotate, setIsAutoRotate] = useState(true);
  const textWrapperRef = useRef(null);
  const measureContainerRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  const autoRotateTiming = 3000;

  const handleSelectMember = useCallback((index) => {
    setActiveIndex(index);
    setIsAutoRotate(false);
  }, []);

  useEffect(() => {
    if (!isAutoRotate || team.length <= 1) return undefined;
    const intervalId = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % team.length);
    }, autoRotateTiming);
    return () => clearInterval(intervalId);
  }, [isAutoRotate, team.length]);

  const recalculateContentHeight = useCallback(() => {
    if (!measureContainerRef.current) return;
    const blocks = Array.from(measureContainerRef.current.children);
    const nextHeight = Math.max(...blocks.map((block) => block.offsetHeight || 0), 0);
    if (nextHeight) {
      setContentHeight(nextHeight);
    }
  }, []);

  useEffect(() => {
    recalculateContentHeight();
    window.addEventListener("resize", recalculateContentHeight);
    return () => {
      window.removeEventListener("resize", recalculateContentHeight);
    };
  }, [recalculateContentHeight, isDarkTheme, team]);

  return (
    <div className="z-[20] mt-[60px] mb-[20px] m-[auto]">
      <TitlesLandingPage titleText="تیم ما" isDarkTheme={isDarkTheme} />
      <div
        className={`relative mt-5 px-4 py-12 rounded-[0px]  ${
          isDarkTheme ? " bg-transparent from-[#0f1729] to-[#050712]" : ""
        } overflow-hidden`}
      >
        <div className="absolute inset-0 pointer-events-none">
          <div
            className={`absolute -top-32 left-1/2 -translate-x-1/2 w-[420px] h-[420px] rounded-full blur-3xl opacity-70 ${
              isDarkTheme ? "bg-[#594ffd]/30" : "bg-[#b3c7ff]/50"
            }`}
          />
          <div
            className={`absolute -bottom-20 right-10 w-[280px] h-[280px] rounded-full blur-[120px] opacity-40 ${
              isDarkTheme ? "bg-[#6cf0c2]/30" : "bg-[#c7ffee]/60"
            }`}
          />
        </div>

        <div className="relative z-10 flex flex-col items-center text-center gap-8 max-w-5xl mx-auto">
          <div className="relative h-32 sm:h-36 w-full flex justify-center">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[360px] h-[360px] pointer-events-none">
              <div
                className={`absolute inset-0 rounded-full ${
                  isDarkTheme ? "bg-gradient-to-b from-[#594ffd]/30 via-transparent to-transparent" : "bg-gradient-to-b from-[#c7d7ff]/50 via-transparent to-transparent"
                }`}
              />
            </div>
            <AnimatePresence mode="wait">
              <motion.div
                key={team[activeIndex].name}
                initial={{ opacity: 0, rotate: -60, scale: 0.8 }}
                animate={{ opacity: 1, rotate: 0, scale: 1 }}
                exit={{ opacity: 0, rotate: 60, scale: 0.8 }}
                transition={{ duration: 0.6, ease: [0.68, -0.3, 0.32, 1] }}
                className="relative"
              >
                <img
                  src={team[activeIndex].avatar}
                  alt={team[activeIndex].name}
                  className="w-36 h-36 sm:w-40 sm:h-40 rounded-full object-cover border-4 border-white/60 shadow-2xl"
                />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="w-full max-w-3xl">
            <div
              ref={textWrapperRef}
              className="relative transition-all duration-300 ease-in-out"
              style={{ height: contentHeight || "auto" }}
            >
              <AnimatePresence mode="wait">
                <motion.div
                  key={`${team[activeIndex].name}-text`}
                  data-active="true"
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -12, position: "absolute", inset: 0 }}
                  transition={{ duration: 0.45 }}
                  className="px-4"
                >
                  <p
                    className={`text-lg sm:text-xl md:text-2xl font-bold leading-9 ${
                      isDarkTheme ? "text-white" : "text-slate-900"
                    } before:content-['\\201C'] after:content-['\\201D']`}
                  >
                    {team[activeIndex].bio}
                  </p>
                  <div className="mt-2 flex flex-col items-center gap-2 ">
                    <p className={`text-sm ${isDarkTheme ? "bg-indigo-700 text-gray-200 px-2 py-1 rounded-full" : "bg-indigo-700 text-gray-200 px-2 py-1 rounded-full"}`}>
                      {team[activeIndex].role}
                    </p>
                    {team[activeIndex].linkedin && (
                      <a
                        href={team[activeIndex].linkedin}
                        target="_blank"
                        rel="noreferrer"
                        className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs sm:text-sm font-medium transition ${
                          isDarkTheme
                            ? "bg-white/10 text-white hover:bg-white/20"
                            : "bg-indigo-100 text-indigo-700 hover:bg-indigo-100"
                        }`}
                      >
                        <span className="mt-1">لینکدین</span>
                        <FiLinkedin size={16}  />
                      </a>
                    )}
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
            <div
              ref={measureContainerRef}
              aria-hidden="true"
              className="absolute top-0 left-0 w-full opacity-0 pointer-events-none select-none -z-10"
            >
              {team.map((member) => (
                <div key={`${member.name}-measure`} className="px-4">
                  <p
                    className={`text-lg sm:text-xl md:text-2xl font-bold leading-9 ${
                      isDarkTheme ? "text-white" : "text-slate-900"
                    } before:content-['\\201C'] after:content-['\\201D']`}
                  >
                    {member.bio}
                  </p>
                  <div className="mt-6 flex flex-col items-center gap-2">
                    <p className={`text-sm ${isDarkTheme ? "text-[#25A6E9]" : "text-indigo-600"}`}>
                      {member.role}
                    </p>
                    {member.linkedin && (
                      <span
                        className={`inline-flex items-center gap-2 rounded-full px-5 py-2 text-xs sm:text-sm font-medium ${
                          isDarkTheme ? "bg-white/10 text-white" : "bg-indigo-50 text-indigo-700"
                        }`}
                      >
                        <FiLinkedin size={16} />
                        <span>LinkedIn</span>
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-wrap mt-2  justify-center gap-2 w-full">
            {team.map((member, index) => {
              const isActive = index === activeIndex;
              return (
                <button
                  key={member.name}
                  type="button"
                  onClick={() => handleSelectMember(index)}
                  className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs sm:text-sm shadow-sm transition-colors ${
                    isActive
                      ? "bg-indigo-500 text-white shadow-indigo-900/30"
                      : isDarkTheme
                      ? "bg-[#0d1324] text-white/80 hover:bg-[#141b2f]"
                      : "bg-white text-slate-900 hover:bg-indigo-50"
                  }`}
                >
                  <span className="font-medium">{member.name}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
